// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const sourceserviceClient = createTypedClient();
export const createSourceserviceClient = (config) => createTypedClient(config);
